import React from 'react'
import { useRoutes, usePath, navigate } from 'raviger'
import { useStore } from 'laco-react'

import UserStore from 'Store/user'

import Base from 'Views/Base'
import Home from 'Views/Home'
import Login from 'Views/Login'
import Logout from 'Views/Logout'
import Admin from 'Views/Admin'

const loginPath = '/login'

export const routes = {
  '/': () => <Home />,
  [loginPath]: () => <Login />,
  '/logout': () => <Logout />,
  '/admin/:tab': ({ tab }) => <Admin tab={tab} />
}

export default () => {
  const path = usePath()
  const userStore = useStore(UserStore)
  if (!userStore.isLoggedIn && path !== loginPath) {
    navigate(loginPath)
  }

  const newPath = usePath()

  const routeResult = useRoutes(routes)

  if (newPath === loginPath) return routeResult
  return <Base>{routeResult}</Base>
}
